import React from "react";
// @material-ui/core components
import {makeStyles, withStyles} from "@material-ui/core/styles";
// @material-ui/icons
import Weekend from "@material-ui/icons/Weekend";
import Home from "@material-ui/icons/Home";
import Business from "@material-ui/icons/Business";
import AccountBalance from "@material-ui/icons/AccountBalance";
import Check from "@material-ui/icons/Check";
import Close from "@material-ui/icons/Close";
import Code from "@material-ui/icons/Code";
import OndemandVideoIcon from '@material-ui/icons/OndemandVideo';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import StyleIcon from '@material-ui/icons/Style';
import InsertEmoticonIcon from '@material-ui/icons/InsertEmoticon';
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import Button from "components/CustomButtons/Button.js";
import NavPills from "components/NavPills/NavPills.js";
import Success from "components/Typography/Success.js";
import Danger from "components/Typography/Danger.js";

import blogPostPageStyle from "assets/jss/material-kit-pro-react/views/blogPostPageStyle.js";

import BaseHeader from "./BaseView/BaseHeader";
import Parallax from "../components/Parallax/Parallax";
import BaseFooter from "./BaseView/BaseFooter";
import CardAvatar from "../components/Card/CardAvatar";
import GifIcon from "@material-ui/core/SvgIcon/SvgIcon";
import InfoArea from "../components/InfoArea/InfoArea";
import {getUserOrderInfo, getUserPlans} from "../utils/request";
import PlanItem from "./components/PlanItem";
import storage from "../utils/storage";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import Primary from "../components/Typography/Primary";


class AboutUsOnly extends React.Component {

	constructor(props, context) {
		super(props, context);
		this.state = {
			plansSeries: [],
			userLogin: !(storage.get('token') === null || storage.get('token') === undefined),
			inNewQuery: true,
		};

		document.title = "关于我 - RobinAlgo";

		this.initDate()
	}

	initDate = () => {
		getUserPlans(this.state.userLogin).then(res => {
			this.setState({
				plansSeries: res.data
			})
		})
	};

	userOrderInfo = () => {
		this.setState({
			inNewQuery: false
		});
		getUserOrderInfo().then(res => {
			this.setState({
				inNewQuery: true,
			}, () => {
				this.initDate()
			});

		})
	};

	render() {

		const {classes} = this.props;

		return (
			<div>

				<Parallax image={"https://robinalgo.oss-cn-shanghai.aliyuncs.com/about_bg.jpg"}
						  filter="dark" small>


					<div className={classes.container}>
						<GridContainer justify="center">
							<GridItem xs={12} sm={12} md={8} className={classes.textCenter}>
								<h3 className={classes.title} style={{color: "white"}}>
									关于RobinAlgo
								</h3>
							</GridItem>
						</GridContainer>
					</div>
				</Parallax>


				<div className={classes.main}>
					<div className={classes.container}
						 style={{padding: '24px'}}>
						<Primary>
							<h3>RobinAlgo已经上线了</h3>
						</Primary>
						<p>
							当前RobinAlgo已经正式上线了,
							<br/>详情的话可以看一下<a target={'_blank'}
											 href={'https://mp.weixin.qq.com/s/Ga3M6BcDfw1_2NPsEWZKnA'}>RobinAlgo的上线介绍</a>
							<br/>上线的前的小故事<a target={'_blank'}
											href={'https://mp.weixin.qq.com/s/iT2aIJ71195GiWhyGVjLcg'}>写在RobinAlgo上线的前一天
						</a>
						</p>

						<Primary>
							<h3>介绍视频</h3>
						</Primary>
						<div>
							<video width="100%" controls>
								<source
									src="https://outin-12775ec6a01d11eaaba100163e1a3b4a.oss-cn-shanghai.aliyuncs.com/sv/4a0ac9bc-1751dedc694/4a0ac9bc-1751dedc694.mp4?Expires=1606298589&OSSAccessKeyId=LTAIVVfYx6D0HeL2&Signature=7t9rQBGbcRRwOSFlhHq%2FNXzsLik%3D"
									type="video/mp4"/>
							</video>
						</div>


						<Primary>
							<h3>关于我</h3>
						</Primary>
						<p>
							前四处辗转的前Android程序员, 做过中规中矩的移动端业务开发, 也做过sdk和海外业务<br/>
							进可画页面, 退可加接口, 上可发版维护, 下可系统测试<br/>
							毕竟<b>RobinAlgo</b>是我一个人设计,开发,运营,维护的项目<br/>
							不把自己整的十项全能怎么对得起辞职信上的诗和远方<br/>
						</p>

						<Primary>
							<h3>RobinAlgo的诞生</h3>
						</Primary>
						<p>
							虽然说想给自己打工的念头从毕业到现在一直都有, 也想过先在工作之余搞搞副业, 业务稳定了一点在全职做. 后来发现,
							人的精力果然是有限的<br/>
							今年(2020)三月意料之中离的职, 刚好也帮我下了个决定, <b>RobinAlgo</b>的项目就是在这样的机缘巧合下立项的
						</p>

						<Primary>
							<h3>RobinAlgo的优势</h3>
						</Primary>
						<p>
							目前<b>RobinAlgo</b>的优势包含但不限于以下几点
						</p>
						<li>首当其冲的就是每个题目的动画展示, 高效理解代码实现原理的不二神器</li>
						<li>手绘讲解视频, 思路跟得上, 更方便讲解被理解</li>
						<li>代码详解, 每次都好提供逐行注释的代码, 可以更快的理解代码的实现</li>
						<li>视频精简, 在后期的不断调整的过程中, 保证每期十分钟左右的视频的每分每秒都十分有价值</li>
						<li>思路引导, 不单单局限于单一的解法, 在潜移默化中帮您行程解题的思路</li>
						<li>更多的优势期待您和我一起发现</li>

						<Primary>
							<h3>专题和系列的区别</h3>
						</Primary>
						<p>
							专题来说是一个大的方向的集合, 一般一个专题有50个视频讲解, 在专题中有着许多类型的视频, 系列来说内容关联性就比较强了,
							在一个系列中我也会在有关联性的情况下尽可能多的从不同的方向来讲解, 由于录制的计划, 相同的系列可能被安排在不同的专题中了,
							在后面可能还会根据大家的需求安排录制更多的系列.
						</p>

						
					</div>
				</div>

			</div>
		);
	}
}

export default withStyles(blogPostPageStyle)(AboutUsOnly)